import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Interno from './interno';
import { useSelector } from 'react-redux';
import { SttAlerta } from '@stt-componentes/core-v2';
import Erro from './erro';
import alerta from '../signals/alerta';
import { useSignals } from '@preact/signals-react/runtime';

const Home = () => {
    const alertaRedux = useSelector(state => state.alerta);
    useSignals();

    return (
        <BrowserRouter basename={`/${global.gConfig.basename}`}>
            <Routes>
                <Route path="/erro" exact element={<Erro />} />
                <Route path="*" element={<Interno />} />
            </Routes>
            <SttAlerta {...alertaRedux} />
            <SttAlerta {...alerta.value} />
        </BrowserRouter>
    );
};

export default Home;
